require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-ramiro-lopez.json") })
        }
      }, "path---interview-ramiro-lopez");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-ramiro-lopez!./.cache/json/interview-ramiro-lopez.json
// module id = 704
// module chunks = 231608221292675